const state = {
  acoData: {},
}

const mutations = {
  setData(state, acoData) {
    console.log(acoData, 33)
    state.acoData = acoData
  }

}

export const acoDataModule = {
  namespaced: true,
  state,
  mutations
}